import { Fragment } from 'react';

interface Segment {
  type: 'text' | 'link';
  value: string;
}

const URL_REGEX = /(?:https?:\/\/|www\.)[^\s<>"'()[\]]+/gi;

// Bỏ dấu câu cuối câu (.,;:!?) không thuộc URL
function cleanUrl(url: string): string {
  return url.replace(/[.,;:!?]+$/, '');
}

// Tách văn bản thành các đoạn text/link
export function linkify(text: string): Segment[] {
  if (!text) return [];
  const segments: Segment[] = [];
  let lastIndex = 0;
  const regex = new RegExp(URL_REGEX.source, 'gi');
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    const raw = match[0];
    const url = cleanUrl(raw);
    const endIndex = match.index + raw.length;
    if (match.index > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, match.index) });
    }
    segments.push({ type: 'link', value: url });
    lastIndex = endIndex;
  }
  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }
  return segments;
}

// Lấy danh sách URL đã nhận diện (đã chuẩn hóa href)
export function extractLinks(text: string): string[] {
  return linkify(text)
    .filter((s) => s.type === 'link')
    .map((s) =>
      s.value.startsWith('www.') ? `https://${s.value}` : s.value
    );
}

export function hasLink(text: string): boolean {
  return linkify(text).some((s) => s.type === 'link');
}

function normalizeHref(url: string): string {
  return url.startsWith('www.') ? `https://${url}` : url;
}

interface LinkifiedTextProps {
  text: string;
  className?: string;
}

export default function LinkifiedText({
  text,
  className,
}: LinkifiedTextProps) {
  const segments = linkify(text);
  return (
    <span className={`whitespace-pre-line ${className ?? ''}`}>
      {segments.map((seg, i) =>
        seg.type === 'link' ? (
          <a
            key={i}
            href={normalizeHref(seg.value)}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="break-all text-blue-600 underline decoration-blue-300 underline-offset-2 transition hover:text-blue-700"
          >
            {seg.value}
          </a>
        ) : (
          <Fragment key={i}>{seg.value}</Fragment>
        )
      )}
    </span>
  );
}